import React from 'react';

const statusColors = {
  // Client statuses
  lead: 'bg-primary/10 text-primary border-primary/20',
  active: 'bg-success/10 text-success border-success/20',
  vip: 'bg-primary/20 text-primary border-primary/30',
  past: 'bg-muted text-text-muted border-border',
  
  // Production/Meeting/Document statuses
  planning: 'bg-primary/10 text-primary border-primary/20',
  confirmed: 'bg-success/10 text-success border-success/20',
  scheduled: 'bg-primary/10 text-primary border-primary/20',
  sent: 'bg-primary/10 text-primary border-primary/20',
  signed: 'bg-success/10 text-success border-success/20',
  draft: 'bg-muted text-text-muted border-border',
  completed: 'bg-success/10 text-success border-success/20',
  cancelled: 'bg-muted text-text-muted border-border',
  in_progress: 'bg-primary/10 text-primary border-primary/20',
  
  // Invoice statuses
  unpaid: 'bg-alert/10 text-alert border-alert/20',
  paid: 'bg-success/10 text-success border-success/20',
};

export function StatusBadge({ status }) {
  const colorClass = statusColors[status] || 'bg-muted text-text-muted border-border';
  
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium border ${colorClass}`}
      data-testid={`status-badge-${status}`}
    >
      {status.replace('_', ' ')}
    </span>
  );
}
